import * as download from 'downloadjs'
import { parse } from 'json2csv'
import * as json2xml from 'json2xml'

export function downloadXml(data: any, fileName: string) {
    
    const csv = json2xml(data);
    download(csv, fileName);

}